"use strict";
var counto_directive_1 = require('./src/counto.directive');
exports.CountoDirective = counto_directive_1.CountoDirective;
var counto_module_1 = require('./src/counto.module');
exports.CountoModule = counto_module_1.CountoModule;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = counto_module_1.CountoModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-counto/index.js
// module id = 133
// module chunks = 3